<mat-nav-list
  [ngClass]="{ secondaryMenu: secondaryMenu, primary: !secondaryMenu }"
  [style.maxHeight]="menu.open && checkForChildMenu() ? '1200px' : '48px'"
>
  <mat-list-item
    matTooltipPosition="right"
    [matTooltip]="menu.name | translate"
    (click)="menu.open = !menu.open"
    *ngIf="menu.link == false"
  >
    <mat-icon matListItemIcon iconsmall *ngIf="menu.mat_icon">
      {{ menu.mat_icon }}
    </mat-icon>
    <mat-icon matListItemIcon iconsmall *ngIf="menu.fa_icon">
      <i class="fa fa-{{ menu.fa_icon }}"></i>
    </mat-icon>
    <h3 matLine *ngIf="!iconOnly">{{ menu.name | translate }}</h3>
    <mat-chip-listbox *ngIf="menu?.chip && !iconOnly">
      <mat-chip-option>{{ menu?.chip?.value }} </mat-chip-option>
    </mat-chip-listbox>
    <mat-icon
      class="sidenav-dropdown-indicator rotate"
      [ngClass]="{ indicateOpen: menu.open }"
      *ngIf="checkForChildMenu()"
    >
      expand_more
    </mat-icon>
  </mat-list-item>

  <mat-list-item
    matTooltipPosition="right"
    routerLinkActive="active"
    [fragment]="menu.fragment"
    [matTooltip]="menu.name | translate"
    [queryParams]="menu.params"
    [routerLink]="[menu.link]"
    (click)="menu.open = !menu.open"
    *ngIf="menu.link != false"
  >
    <mat-icon matListItemIcon iconsmall *ngIf="menu.mat_icon">
      {{ menu.mat_icon }}
    </mat-icon>
    <mat-icon matListItemIcon iconsmall *ngIf="menu.fa_icon">
      <i class="fa fa-{{ menu.fa_icon }}"></i>
    </mat-icon>
    <h3 matLine *ngIf="!iconOnly">{{ menu.name | translate }}</h3>
    <mat-icon
      class="sidenav-dropdown-indicator rotate"
      [ngClass]="{ indicateOpen: menu.open }"
      *ngIf="checkForChildMenu()"
    >
      expand_more
    </mat-icon>
  </mat-list-item>

  <!-- Sub Menu Items -->
  <cube-sidemenu-item
    [iconOnly]="iconOnly"
    [menu]="submenu"
    [secondaryMenu]="true"
    *ngFor="let submenu of menu?.sub"
  ></cube-sidemenu-item>
</mat-nav-list>
